import { useState, useEffect, useCallback } from 'react';

// Hook personalizado para debounce
export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

// Hook para navegação automática na pesquisa
export const useSearchNavigation = (navigate, location, onCategoryFilter) => {
  const handleSearchWithNavigation = useCallback((searchValue) => {
    // Se o usuário começou a digitar e não está na página shop, navegar para lá
    if (searchValue.trim().length > 0 && location.pathname !== '/shop') {
      // Limpar filtro de categoria ao fazer uma nova pesquisa
      if (onCategoryFilter) {
        onCategoryFilter('');
      }
      navigate('/shop');
    }
  }, [navigate, location.pathname, onCategoryFilter]);

  return handleSearchWithNavigation;
};
